import {
  countriesAsSelectioOptions,
  phonePrefixesAsSelectionOptions,
} from '../../constants/countries'

/** Form values collected on the repair kit request step. */
export interface RepairKitRequestFormValues {
  email: string
  firstName: string
  lastName: string
  address: string
  /** Street line only — sent to the API / Google Sheet; hidden from the user. */
  streetAddress: string
  additionalAddress: string
  zip: string
  city: string
  country: string
  phonePrefix: string
  phone: string
  /** UI-only: true when the user picked a suggestion with a street number. */
  addressComplete: boolean
  /** Must be checked on the confirmation step before the kit request is sent. */
  readConfirmation: boolean
}

/**
 * Resolve a select option label from its stored value.
 */
export const getSelectLabel = (
  options: { label: string; value: string }[],
  value: string,
): string => options.find(option => option.value === value)?.label ?? value

/** Delivery and contact fields shown on the kit confirmation step. */
export const KIT_CONFIRMATION_FIELDS: {
  labelKey: string
  getValue: (values: RepairKitRequestFormValues) => string
}[] = [
  { labelKey: 'fields.email', getValue: values => values.email },
  { labelKey: 'fields.lastName', getValue: values => values.firstName },
  { labelKey: 'fields.firstName', getValue: values => values.lastName },
  {
    labelKey: 'fields.country',
    getValue: values => getSelectLabel(countriesAsSelectioOptions, values.country),
  },
  { labelKey: 'fields.deliveryAddress', getValue: values => values.address },
  {
    labelKey: 'fields.additionalAddress',
    getValue: values => values.additionalAddress || '—',
  },
  { labelKey: 'fields.zip', getValue: values => values.zip },
  { labelKey: 'fields.city', getValue: values => values.city },
  {
    labelKey: 'fields.phonePrefix',
    getValue: values => getSelectLabel(phonePrefixesAsSelectionOptions, values.phonePrefix),
  },
  { labelKey: 'fields.phone', getValue: values => values.phone },
]
